import React from 'react'

import { NewsNews } from 'api/models'
import { Image, Skeleton } from 'shared/components'
import { dateToLocaleString } from 'shared/utils'

import classes from './NewsListItem.module.scss'

type Props = {
  item: NewsNews
}
export const NewsListItem: React.FC<Props> = ({ item }): JSX.Element => {
  const renderImg = () => {
    if (!item?.id) {
      return <Skeleton className={classes.img_container} height="150px" />
    }

    return (
      <div className={classes.img_container}>
        <Image
          className={classes.img}
          src={item.imgSquare?.href}
          alt="news_item"
        />
      </div>
    )
  }

  const renderDate = () => {
    if (!item?.id) {
      return <Skeleton />
    }

    return (
      <>
        {'  \u00B7  '}
        {dateToLocaleString(item.date, false, false, true)}
      </>
    )
  }

  const renderType = () => {
    if (!item?.id) {
      return <Skeleton />
    }

    const isRubricArray =
      Array.isArray(item?.rubric) && item?.rubric?.length > 0

    return isRubricArray ? item.rubric[0] : ''
  }

  return (
    <div className={classes.item}>
      {renderImg()}
      <div className={classes.item_container}>
        <span className={classes.item_descr}>{item.title || <Skeleton />}</span>
        <div className={classes.item_info}>
          <small className={classes.item_info_type}>{renderType()}</small>
          <small className={classes.item_info_date}>{renderDate()}</small>
        </div>
      </div>
    </div>
  )
}
